import Lenis from "lenis";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Constants
const MOBILE_VIEWPORT_WIDTH = "767px";
const EASING_DEFAULT = "power1.out";
const STAGGER_DURATION = 0.275;
const FADE= { from: { opacity: 0 }, to: { opacity: 1 } };

(() => {
    
    // Disable for users that prefer reduced motion
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReducedMotion) return;

    // Disable for devices with smaller viewports
    const isMobile = window.matchMedia(`(max-width: ${MOBILE_VIEWPORT_WIDTH})`).matches;
    if (isMobile) return;

    // Otherwise, continue with the smooth scrolling library and animations
    const lenis = new Lenis();

    function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
    
    // Enable GSAP's Scroll Trigger
    gsap.registerPlugin(ScrollTrigger);
    lenis.on("scroll", ScrollTrigger.update)

    gsap.ticker.add((time)=>{
        lenis.raf(time * 1000)
    })

    gsap.ticker.lagSmoothing(0);

    // Apply a separate Lenis (smooth scroll) instance that listens for the CIVIC settings panel
    const civicId = "ccc-content";

    function initialiseCivicLenis() {
        const civicSettingsPanel = document.querySelector(`#${civicId}`);
        
        if (civicSettingsPanel) {
            const civicLenis = new Lenis({
                autoRaf: true,
                wrapper: civicSettingsPanel,
                content: civicSettingsPanel.querySelector(".ccc-panel")
            });

            civicLenis.start();
            return true;
        }

        return false;
    }

    if (!initialiseCivicLenis()) {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    const civicElement = node.nodeType === 1 && (node.id === civicId || node.querySelector(`#${civicId}`));
                    
                    if (civicElement && initialiseCivicLenis()) {
                        observer.disconnect();
                    }
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
    
    // Attach Scroll Trigger to page elements
    const elements = document.querySelectorAll('[data-scroll-trigger]');

    elements.forEach((element) => {
        // Get the easing function from the data attribute or default to "power1.out"
        const easing = element.getAttribute("data-scroll-trigger-ease") || EASING_DEFAULT;

        // Setup the animation for this element...
        setupAnimation(element, easing, FADE);
        
        // If the element has children...
        var children = element.querySelector(".panel--article-cards, .Brow111, .client-carousel__items");
        if(children) fadeChildren(children, easing);

        children = element.querySelectorAll(".Brow111");
        if(children?.length) children.forEach(child => fadeChildren(child, easing));

    });

    // Set up GSAP animation with ScrollTrigger
    function setupAnimation(element, easing, transition) {

        // Calculate an effective offset value to begin the animation
        const elementHeight = element.clientHeight ?? element[0]?.clientHeight;
        const startOffset = Math.min(elementHeight / 2, window.innerHeight * .2);

        // Setup Scroll Trigger to control the transition
        gsap.fromTo(
            element,
            {
                ...transition.from
            },
            {
                ...transition.to,
                ease: easing ?? EASING_DEFAULT,
                scrollTrigger: {
                    trigger: element,
                    start: `top bottom-=${startOffset}px`,
                    toggleActions: "play none none reverse",
                }
            }
        );
    }
    
    function fadeChildren(parentElement, easing) {
        setupAnimation(parentElement.children, easing, {
            from: { ...FADE.from },
            to: { ...FADE.to, stagger: STAGGER_DURATION }
        });
    }
})();